import React from 'react';
import { Typography } from '@mui/material';

const DateInTable = ({ date }) => {
  return (
    <Typography variant="body2">
      {date}
    </Typography>
  );
};

export default DateInTable;
